import { Link } from "react-router-dom";

export default function Orders({ id, status, products, date }) {
  return (
    <tr>
      <td className="align-middle border-top-0 w-0">
        {products?.map((product, index) => (
          <div key={index} className="mb-2">
            <img
              src={product.image}
              alt={product.title}
              className="icon-shape icon-xl"
            />
          </div>
        ))}
      </td>

      <td className="align-middle border-top-0">
        {products?.map((product, index) => (
          <div key={index} className="mb-2">
            <h6 className="mb-0">{product.title}</h6>
            <small className="text-muted">{product.type} x {product.quantity}</small>
          </div>
        ))}
      </td>

      <td className="align-middle border-top-0">
        <Link to="#" className="text-inherit">
          {id}
        </Link>
      </td>
      <td className="align-middle border-top-0">{date}</td>

      {/* <td className="align-middle border-top-0">
        {products?.map((product, index) => (
          <div key={index} className="mb-2">
            {product.quantity}
          </div>
        ))}
      </td> */}

      <td className="align-middle border-top-0">
        <span className="badge bg-warning">{status}</span>
      </td>

      <td className="align-middle border-top-0">
        {products?.map((product, index) => (
          <div key={index} className="mb-2">
            ₹{product.price}
          </div>
        ))}
      </td>

      <td className="align-middle">
        <Link
          to={`/OrderDetails?orderId=${id}`}
          className="btn btn-sm btn-outline-primary"
          title="View Product"
        >
          <i className="bi bi-eye"></i>
        </Link>
      </td>

      {/* {products?.map((product)=>(
         <td className="align-middle border-top-0 w-0">
        <Link to="#">
          {" "}
          <img
            src={product.image}
            alt="Ecommerce"
            className="icon-shape icon-xl"
          />
        </Link>
      </td>
      ))}

       {products?.map((product)=>(
         <td className="align-middle border-top-0">
        <Link to="#" className="fw-semi-bold text-inherit">
          <h6 className="mb-0">{product.title}</h6>
        </Link>
        <span>
          <small className="text-muted">{product.type}</small>
        </span>
      </td>
      ))}

       {products?.map((product)=>(
        <td className="align-middle border-top-0">{product.quantity}</td>
      ))}
       {products?.map((product)=>(
         <td className="align-middle border-top-0">
        <span className="badge bg-warning">{status}</span>
      </td>
      ))}
       {products?.map((product)=>(
        <td className="align-middle border-top-0">₹{product.price}</td>
      ))}
      */}
    </tr>
  );
}
